const defaultCurrencyFormat = {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'narrowSymbol',
}

const defaultPercentageFormat = {
    percent: {
        style: 'percent',
        useGrouping: false,
    },
}

const defaultUnitFormat = {
    liter: {
        style: 'unit',
        unit: 'liter',
        unitDisplay: 'narrow',
    },
    weight: {
        style: 'unit',
        unit: 'gram',
        unitDisplay: 'narrow',
    },
    length: {
        style: 'unit',
        unit: 'centimeter',
        unitDisplay: 'narrow',
    },
    numberAbbreviation: {
        style: 'decimal',
        notation: 'compact',
        maximumFractionDigits: 1,
    },
}

const integerCurrencyFormat = {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
}

export const DEFAULT_LOCALE = 'en'

export const LOCALES = [
    {
        code: 'en',
        name: 'English',
        iso: 'en-GB',
        file: 'en.json',
    },
    {
        code: 'nl',
        name: 'Nederlands',
        iso: 'nl-NL',
        file: 'nl.json',
    },
    {
        code: 'de',
        name: 'Deutsch',
        iso: 'de-DE',
        file: 'de-DE.json',
    },
    {
        code: 'fr',
        name: 'Français',
        iso: 'fr-FR',
        file: 'fr-FR.json',
    },
    {
        code: 'pl',
        name: 'Polski',
        iso: 'pl-PL',
        file: 'pl-PL.json',
    },
    {
        code: 'da',
        name: 'Dansk',
        iso: 'da-DK',
        file: 'da-DK.json',
    },
    {
        code: 'it',
        name: 'Italiano',
        iso: 'it-IT',
        file: 'it-IT.json',
    },
    {
        code: 'es',
        name: 'Español',
        iso: 'es-ES',
        file: 'es-ES.json',
    },
]

export const AVAILABLE_LOCALES = LOCALES.map((item) => item.code)

export const NUMBER_FORMATS = {
    en: {
        currency: {
            ...defaultCurrencyFormat,
        },
        'currency-no-decimal': {
            ...defaultCurrencyFormat,
            ...integerCurrencyFormat,
        },
        ...defaultPercentageFormat,
        ...defaultUnitFormat,
    },
    nl: {
        currency: {
            ...defaultCurrencyFormat,
        },
        'currency-no-decimal': {
            ...defaultCurrencyFormat,
            ...integerCurrencyFormat,
        },
        ...defaultPercentageFormat,
        ...defaultUnitFormat,
    },
    de: {
        currency: {
            ...defaultCurrencyFormat,
        },
        'currency-no-decimal': {
            ...defaultCurrencyFormat,
            ...integerCurrencyFormat,
        },
        ...defaultPercentageFormat,
        ...defaultUnitFormat,
    },
    fr: {
        currency: {
            ...defaultCurrencyFormat,
        },
        'currency-no-decimal': {
            ...defaultCurrencyFormat,
            ...integerCurrencyFormat,
        },
        ...defaultPercentageFormat,
        ...defaultUnitFormat,
    },
    it: {
        currency: {
            ...defaultCurrencyFormat,
        },
        'currency-no-decimal': {
            ...defaultCurrencyFormat,
            ...integerCurrencyFormat,
        },
        ...defaultPercentageFormat,
        ...defaultUnitFormat,
    },
    es: {
        currency: {
            ...defaultCurrencyFormat,
        },
        'currency-no-decimal': {
            ...defaultCurrencyFormat,
            ...integerCurrencyFormat,
        },
        ...defaultPercentageFormat,
        ...defaultUnitFormat,
    },
    da: {
        currency: {
            ...defaultCurrencyFormat,
        },
        'currency-no-decimal': {
            ...defaultCurrencyFormat,
            ...integerCurrencyFormat,
        },
        ...defaultPercentageFormat,
        ...defaultUnitFormat,
    },
    pl: {
        currency: {
            ...defaultCurrencyFormat,
        },
        'currency-no-decimal': {
            ...defaultCurrencyFormat,
            ...integerCurrencyFormat,
        },
        ...defaultPercentageFormat,
        ...defaultUnitFormat,
    },
}

export const PLURALIZATION_RULES = {
    pl: function (choice) {
        if (choice > 2 && choice < 5) {
            return 2
        }
        if (choice >= 5) {
            return 3
        }
        return choice
    },
}
